import React from "react";
import Chart from "react-apexcharts";

export default function IncomeBarChart({
  title,

  categories,

  series,

  colors = ["#3b82f6"],

  height = 300,

  showLegend = false,
  gridType = "both",
}) {
  const options = {
    chart: {
      toolbar: { show: false },
    },

    plotOptions: {
      bar: {
        columnWidth: "45%",
        borderRadius: 4,
      },
    },

    xaxis: {
      categories,
      labels: {
        style: {
          fontSize: "12px",
          colors: "#666666",
          fontWeight: "400",
        },
      },
      axisBorder: {
        show: true,
        color: "#666666",
      },
    },

    yaxis: {
      labels: {
        style: {
          colors: "#666666",
          fontSize: "12px",
          fontWeight: "400",
        },
      },
      axisBorder: {
        show: true,
        color: "#666666",
      },
    },

    legend: {
      show: showLegend,
      showForSingleSeries: true,
      position: "bottom",
      horizontalAlign: "center",
      fontSize: "13px",
    },

    dataLabels: {
      enabled: false,
    },

    grid: {
      borderColor: "#CCCCCC",
      strokeDashArray: 4,
      padding: {
        left: 13,
      },

      xaxis: {
        lines: {
          show: gridType === "both" || gridType === "vertical",
        },
      },
      yaxis: {
        lines: {
          show: gridType === "both" || gridType === "horizontal",
        },
      },
    },
    colors,
  };

  return (
    <div>
      <h4
        style={{
          fontSize: "20px",
          marginBottom: "10px",
          marginTop: "10px",
          fontWeight: "600",
          color: "#0A0A0A",
        }}
      >
        {title}
      </h4>

      <Chart options={options} series={series} type="bar" height={height} />
    </div>
  );
}
